exports.formatMoney = (value) => {
    if (value) {
        value = Number(value)
        return '￥' + value.toFixed(2)
    }
    return '￥' + 0
}

exports.getOrderStatusName = (val) => {
    let statusName = ''
    switch (val) {
    case 0: {
        statusName = '未付款'
        break
    }
    case 1: {
        statusName = '已付款'
        break
    }
    case 2: {
        statusName = '已发货'
        break
    }
    case 3: {
        statusName = '已签收'
        break
    }
    case -1: {
        statusName = '退货申请'
        break
    }
    case -2: {
        statusName = '退货中'
        break
    }
    case -3: {
        statusName = '已退货'
        break
    }
    case -4: {
        statusName = '取消交易'
        break
    }
    }
    return statusName
}

exports.formatterPayType = (val) => {
    let statusName = ''
    switch (val) {
    case '0': {
        statusName = '余额'
        break
    }
    case '1': {
        statusName = '代金券'
        break
    }
    case '2': {
        statusName = 'U币'
        break
    }
    case '3': {
        statusName = '微信'
        break
    }
    case '4': {
        statusName = '支付宝'
        break
    }
    case '5': {
        statusName = '收银宝'
        break
    }
    case '6': {
        statusName = '通联'
        break
    }
    case 0: {
        statusName = '余额'
        break
    }
    case 1: {
        statusName = '代金券'
        break
    }
    case 2: {
        statusName = 'U币'
        break
    }
    case 3: {
        statusName = '微信'
        break
    }
    case 4: {
        statusName = '支付宝'
        break
    }
    case 5: {
        statusName = '收银宝'
        break
    }
    case 6: {
        statusName = '通联'
        break
    }
    }
    return statusName
}



// WEBPACK FOOTER //
// ./src/filters/index.js